<template>
  <div class="agreement_page">
    <div class="agreement_title">{{info.title}}</div>
    <div class="agreement_content" v-html="info.content"></div>
    <!-- <h1>《活动个人安全免责协议书》</h1>
    <div class="content">
      <p style="font-weight:600;"></p>
      <p><span style="font-weight:600;">第一条 </span>
      本次户外活动本着自愿参加与退出，风险与责任自负的原则。参与者应有必要的风险意识，谨防户外活动风险。</p>
      <p><span style="font-weight:600;">第二条 </span> 本协议书为强制性必签协议。同意本协议意味着接受并同意承担本协议的全部义务，不同意意味着放弃参加此次活动的权利。</p>
      <p>
      <span style="font-weight:600;">第三条 </span> 参加本次活动者必须遵守中华人民共和国的相关法律、法规，必须遵循道徳和社会公德规范，对违反相关法律，违反现场秩序或造成安全风险的行为人，组织方有权取消其活动参与资格。</p>
      <p>
      <span style="font-weight:600;">第四条 </span> 参加本次活动人员应该是成年人（具有完全民小行为能力的人，18周岁 以上）。</p>
      <p>
      <span style="font-weight:600;">第五条 </span> 参加活动者在此次活动期间的个体人身安全责任自负。鼓励参加者自行购买人身安全保险。活动中一旦出现事故，活动中任何非事故当事人将不承担人身事故的任何责任，但有互相援助的义务。参加活动的成员应当积极主动的组织实施救援工作，但对事故本身不承担任何法律责任和经济责任。</p>
      <p>
      <span style="font-weight:600;">第六条 </span> 本次活动召集人、组织者对参加本次活动者的人身安全不负有民事及相关连带责任。</p>
      <p>
      <span style="font-weight:600;">第七条 </span> 参与本次的活动者，应积极配合新冠疫情防疫工作，主动出示健康码、行程码、疫苗接种等有关信息，不得隐瞒有碍疫情防控的相关情况。</p>
      <p style="font-weight:600;padding-left: 28px;">我已经认真阅读上述条款，并且同意</p>
      <p></p>
    </div> -->
  </div>
</template>

<script>
  import content from '../../api/content';
  export default {
    data () {
      return {
        info:'',
      }
    },
    created () {
      this.$store.commit('param/show', false)

      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
      this.getAgreement(6)
    },
    methods: {
      getAgreement(id){
        content.getAgreement({id:id}).then(res => {
          this.info=res.data.data
        })
      },
    }
  };
</script>

<style lang="scss">
  .agreement_page {
    padding: 10px;
  }
</style>
